module.exports = __webpack_public_path__ + "static/media/em-226.958065f3.png";